<template>
  <ul class="gaming-aside-score">
    <li>
      <GamingButtonXp class="button" to="/gaming" />
    </li>
    <li>
      <GamingButtonStreak class="button" to="/gaming#streak" />
    </li>
    <li>
      <GamingButtonLevel class="button" to="/gaming#level" />
    </li>
  </ul>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.gaming-aside-score {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  gap: var(--gap_s);

  @include above('xl') {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }
}
</style>
